import api from "../api/axios";
import dayjs from "dayjs";

async function createAgreement(agreementData) {
  const response = await api.post(
    "/api/v1/agreements",
    getAgreementFormData(agreementData, [], "")
  );

  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

async function updateAgreement(id, agreementData, newFiles,  removedFiles) {
  const response = await api.put(
    "/api/v1/agreements/" + id,
    getAgreementFormData(agreementData, newFiles, "edit", removedFiles)
  );
  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

async function updateAnalyzeAgreement(reportId, agreement_id, analyzeData, newFiles = [], removedFiles = []) {
  const formData = new FormData();

  // Campos básicos del report
  formData.append("report[agreement_id]", agreement_id);
  formData.append("report[academic_unit]", analyzeData.academic_unit);
  formData.append("report[career]", analyzeData.career);
  formData.append("report[proposal]", analyzeData.proposal);
  formData.append("report[evaluated_period]", analyzeData.evaluated_period);
  formData.append("report[evaluation_unit]", analyzeData.evaluation_unit);
  formData.append("report[presentation_date]", analyzeData.presentation_date);
  formData.append("report[observation]", analyzeData.observation);

  // Coordinadores: enviarlos correctamente como array de hashes
  analyzeData.coordinators.forEach((c, index) => {
    formData.append(`report[coordinators][${index}][name]`, c.name);
  });

  // Archivos nuevos: solo File o Blob
  newFiles.forEach((file) => {
    if (file instanceof File || file instanceof Blob) {
      formData.append("report[files][]", file);
    }
  });

  // Archivos eliminados: como JSON string
  formData.append("report[removed_files]", JSON.stringify(removedFiles));

  // Llamada PUT al backend
  const response = await api.put(`/api/v1/reports/${reportId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  if (!response || response.status >= 400) {
    throw new Error(response.statusText || "Error al actualizar el reporte");
  }

  return response.data;
}




async function createAnalyzeAgreement(agreement_id, analyzeData, files = []) {
  const formData = new FormData();

  formData.append("report[agreement_id]", agreement_id);
  formData.append("report[academic_unit]", analyzeData.academic_unit);
  formData.append("report[career]", analyzeData.career);
  formData.append("report[proposal]", analyzeData.proposal);
  formData.append("report[evaluated_period]", analyzeData.evaluated_period);
  formData.append("report[evaluation_unit]", analyzeData.evaluation_unit);
  formData.append("report[presentation_date]", analyzeData.presentation_date);
  formData.append("report[observation]", analyzeData.observation);

  // coordinators como array de hashes
  analyzeData.coordinators.forEach((c) => {
    formData.append("report[coordinators][][name]", c.name);
  });

  // adjuntar archivos
  files.forEach((file) => {
    formData.append("report[files][]", file);
  });

  const response = await api.post("/api/v1/reports", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}


async function getAgreement(url) {
  const response = await api.get(url);
  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

async function getAgreementAnalyze(agreementId) {
  const response = await api.get("/api/v1/reports/" + agreementId);
  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

async function getReport(agreementId) {
  const response = await api.get(
    "/api/v1/reports/" + agreementId + "/public_show"
  );
  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

async function getAgreementAll(page = 1) {
  const response = await api.get(`/api/v1/agreements?page=${page}`);
  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

async function updateAgreementStatus(id, statusData) {
  const response = await api.patch(
    `/api/v1/agreements/${id}`,
    { status: statusData }
  );
  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

async function searchAgreements(query, page = 1, status = "all", filters = {}) {
  
  const params = new URLSearchParams();
  if (query && query.trim() !== "") {
    params.append("q", query);
  }
  params.append("page", page);

  if (status && status !== "all") params.append("status", status);
  if (filters.typeFilter) params.append("type", filters.typeFilter);
  appendDateParam(params, "subscription_from", filters.subscriptionFrom);
  appendDateParam(params, "subscription_to", filters.subscriptionTo);
  appendDateParam(params, "validity_from", filters.validityFrom);
  appendDateParam(params, "validity_to", filters.validityTo);


  return api.get(`/api/v1/search/agreements?${params.toString()}`);
}

function appendDateParam(params, key, value) {
  const parsed = dayjs(value);
  if (parsed.isValid()) {
    params.append(key, parsed.format("YYYY-MM-DD"));
  }
}


function getAgreementFormData(agreementData, newFiles, action, removedFiles = []) {
  
  const tam =
    newFiles.length > 0
      ? Array.from(newFiles).length
      : Array.from(agreementData.files).length;
  const formData = new FormData();

  if (action === "edit") {
    formData.append("agreement[status]", agreementData.status);
  }
  formData.append("agreement[order_number]", agreementData.order_number);
  formData.append("agreement[agreement_type]", agreementData.agreement_type);
  formData.append("agreement[objective]", agreementData.objective);
  formData.append("agreement[entity]", agreementData.entity);
  formData.append(
    "agreement[resolution_number]",
    agreementData.resolution_number
  );
  formData.append(
    "agreement[suscription_date]",
    agreementData.suscription_date
  );
  formData.append("agreement[effective_date]", agreementData.effective_date);
  formData.append("agreement[notification_unit]", agreementData.notification_unit);
  formData.append("agreement[notification_amount]", agreementData.notification_amount);
  formData.append("agreement[proponent_email]", agreementData.proponent_email);
  formData.append("agreement[signers]", JSON.stringify(agreementData.signers));
  for (let i = 0; i < tam; i++) {
    if (newFiles.length > 0) {
      formData.append("agreement[images][]", newFiles[i]);
    }
    if (agreementData.files.length > 0 && action !== "edit") {
      formData.append("agreement[images][]", agreementData.files[i]);
    }
  }

  

  removedFiles.forEach((id) => {
    
    formData.append("agreement[removed_file_ids][]", id);
  });
  
  
  return formData;
}

async function getAgreementsHistory(agreementId, page) {
  const response = await api.get(`/api/v1/agreements/${agreementId}/history`, {
    params: { page },
  });
  if (!response) {
    throw new Error(response.statusText);
  }
  
  return response;
}

async function getPublicAgreements(filters) {
  const response = await api.get(`/api/v1/search/public_agreements`, {
    params: { ...filters },
  });
  if (!response) {
    throw new Error(response.statusText);
  }
  return response;
}

async function exportAgreements(filters = {}, scope = "internal") {
  const queryParams = new URLSearchParams({ ...filters, scope }).toString();
  const response = await api.get(`/api/v1/search/export_agreements?${queryParams}`);
  return response;
}


//IA
async function IAAgreement(formData) {
  const response = await api.post("/api/v1/ai_agreements/summarize",  formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });


  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

async function analyzeReport(file) {
  const formData = new FormData();
  formData.append("file", file); // file debe ser un File real, ej. del input type="file"

  const response = await api.post("/api/v1/ai_analyze_reports/summarize", formData, {
    headers: { "Content-Type": "multipart/form-data" }, // opcional, axios lo detecta solo
  });

  if (!response) throw new Error(response.statusText);
  return response;
}




export {
  createAgreement,
  updateAgreement,
  updateAnalyzeAgreement,
  createAnalyzeAgreement,
  getAgreement,
  getAgreementAnalyze,
  getAgreementAll,
  updateAgreementStatus,
  searchAgreements,
  getAgreementsHistory,
  getReport,
  getPublicAgreements,
  exportAgreements,
  IAAgreement,
  analyzeReport
};
